import * as React from 'react';

import { LocalizedComponentProps, LocalizedText, withLocalization } from 'bernie-l10n';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { DateRange } from 'models';

import { SavingsOption } from './savings-option';
import { SharedUiDatedForm } from 'components/infosite/shared-ui/form/shared-ui-forms';

export type LocalizedExposedSearchFormProps = LocalizedComponentProps & ExposedSearchFormProps;

export interface ExposedSearchFormProps {
  onUpdateResults?: (event: Event, searchCriteriaModel: SearchCriteriaModel, goBack?: boolean) => void;
  metaSavingsOption?: {
    alternateDateRange: DateRange;
    alternateDateMessage: string;
    url: string;
  };
}

@withLocalization
export class ExposedSearchForm extends React.Component<LocalizedExposedSearchFormProps> {
  private handleSharedUiUpdate = (searchCriteria: SearchCriteriaModel): void => {
    this.props.onUpdateResults(null, searchCriteria, false);
  };

  public render() {
    const { metaSavingsOption } = this.props;

    return (
      <div data-stid="section-hotel-search">
        <h3 className="is-visually-hidden">
          <LocalizedText message="hotels.infosite.availabilityWizard.changeSearch.a11yLabel" />
        </h3>

        <SharedUiDatedForm onChange={this.handleSharedUiUpdate} />

        {metaSavingsOption && (
          <div id="meta-savings-message" className="all-b-padding-two">
            <SavingsOption dateOption={metaSavingsOption} />
          </div>
        )}
      </div>
    );
  }
}
